import { useEffect, useState } from "react";
import Tooltip from "@shared/v2/Tooltip";
import IconButton from "@shared/v2/IconButton";
import { CommentSolidV6 } from "@shared/v2/Icomoon";
import SmsModal from "./SmsModal";

const SmsModalButton = ({ person, smsEnabled }) => {
  const [smsModalOpen, setSmsModalOpen] = useState(false);
  const [defaultHomeAppTabContent, setDefaultHomeAppTabContent] = useState("");

  useEffect(() => {
    const homeAppClickListener = (e) => {
      if (e.detail.personId === person.data.attributes.id) {
        setDefaultHomeAppTabContent(e.detail.text);
        setSmsModalOpen(true);
      }
    };

    window.addEventListener("homeAppSmsClick", homeAppClickListener, false);

    return () => {
      window.removeEventListener("homeAppSmsClick", homeAppClickListener);
    };
  }, [person.data.attributes.id]);

  return (
    <div>
      {smsEnabled ? (
        <Tooltip
          placement="right"
          trigger={
            <IconButton aria-label="sms" onClick={() => setSmsModalOpen(true)}>
              <CommentSolidV6 />
            </IconButton>
          }
          content="Send Text"
        />
      ) : (
        <i className="fa fa-commenting-o sms gray" />
      )}
      {smsModalOpen && (
        <SmsModal
          personId={person.data.attributes.id}
          person={person}
          modalOpen={smsModalOpen}
          closeModal={() => setSmsModalOpen(false)}
          defaultHomeAppTabContent={defaultHomeAppTabContent}
        />
      )}
    </div>
  );
};

export default SmsModalButton;
